import settings from '../../../common/services/src/settings/settings'
import interceptorManager from '../../../common/utils/http/interceptor'

interceptorManager.addInterceptor({
		request(config) {
			if(config.doNotIntercept) {
				return config;
			}

			let timestamp = new Date();

			if (!config.headers['Application-Key']) {
				config.headers['Application-Key'] = settings.getApplicationKey();
			}

			if (!config.headers['Tenant-Id']) {
				config.headers['Tenant-Id'] = settings.getTenantOrganizationId();
			}

			config.headers = Object.assign({}, config.headers, {
				'Cache-Control': 'no-cache',
				'If-Modified-Since': '0',
				'Environment-Name': settings.getEnvironmentName(),
				'Time-Zone': ((-1)*(timestamp.getTimezoneOffset())),
				'Request-Timestamp': timestamp.getTime()
			});


			if(!config.headers.Accept) {
				config.headers.Accept = 'application/json';
			}

			return config;
		}
	}
);


// WEBPACK FOOTER //
// ./src/services/httpInterceptor.js